export default {
    methods: {
        // define which colors should be available
        getTiptapBlockColors() {
            return ['rgb(49, 55, 151)'];
        },
        // define the styling string for the color block
        getTiptapBlockStylingString() {
            return 'padding: 16px; padding-bottom: 1px; border-radius: 4px;';
        },
        // define the styling object for the color block
        getTiptapBlockStylingObject(el) {
            el.style.padding = '16px';
            el.style.paddingBottom = '1px';
            el.style.borderRadius = '4px';
            el.style.display = 'block';
            return el;
        },
        getHeadingLevels() {
            return [1,2,3];
        },
        getTiptapHeadingStylingString(h) {
            return 'color:#ff0000;';
        },
    }
}